<template lang="pug">
.calendar_wrapper
  DaySwitcher.day_switch(
    :date_from='date.date_from',
    :date_to='date.date_to',
    @setPreviousWeek='setPreviousWeek',
    @setNextWeek='setNextWeek'
  )
  CalendarBlock(:data='allData', :days='getDays', :loading='loading')
</template>

<script>
import { Spinner as LoadingSpinner } from '@/components/spinners';
import { format } from 'date-fns';
import DaySwitcher from '@/components/parts/catalog/card/components/tabs/schedule/components/schedulecalendar/DaySwitcher';
import CalendarBlock from './CalendarBlock';
export default {
  name: 'SchedulerCalendar',
  components: { CalendarBlock, DaySwitcher, LoadingSpinner },
  inject: ['$api'],
  props: {
    groupId: String,
  },
  data() {
    return {
      loading: true,
      date: {
        date_from: '',
        date_to: '',
      },
      allData: [],
      columns: ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'],
    };
  },
  created() {
    this.setCurrentWeek(false);
  },
  mounted() {
    this.updateData();
  },
  computed: {
    getDays() {
      let ret = [];
      ret.push(format(this.date.date_from, 'YYYY-MM-DD'));
      for (let i = 1; i < 7; i++) {
        let dateFrom = new Date(this.date.date_from);
        dateFrom.setDate(dateFrom.getDate() + i);
        ret.push(format(dateFrom, 'YYYY-MM-DD'));
      }
      return ret;
    },
  },
  methods: {
    setCurrentWeek() {
      this.date.date_from = this.$util
        .getFirstDayOfWeekByDate(new Date())
        .toUTCString();

      this.date.date_to = this.$util
        .getLastDayOfWeekByDate(new Date())
        .toUTCString();
    },
    setPreviousWeek() {
      let dateFrom = new Date(this.date.date_from);
      this.date.date_from = new Date(
        dateFrom.setDate(dateFrom.getDate() - 7)
      ).toUTCString();
      let dateTo = new Date(this.date.date_to);
      this.date.date_to = new Date(
        dateTo.setDate(dateTo.getDate() - 7)
      ).toUTCString();
      this.updateData();
    },
    setNextWeek() {
      let dateFrom = new Date(this.date.date_from);
      this.date.date_from = new Date(
        dateFrom.setDate(dateFrom.getDate() + 7)
      ).toUTCString();
      let dateTo = new Date(this.date.date_to);
      this.date.date_to = new Date(
        dateTo.setDate(dateTo.getDate() + 7)
      ).toUTCString();
      this.updateData();
    },
    async updateData() {
      this.loading = true;
      try {
        let {
          data: { data },
        } = await this.$api.get(
          `event-group/${this.groupId}/schedule?date_from=${format(
            this.date.date_from,
            'YYYY-MM-DD'
          )}&date_to=${format(this.date.date_to, 'YYYY-MM-DD')}`
        );
        this.allData = data;
      } catch (e) {
        // console.log(e);
        this.allData = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.calendar_wrapper
  margin-top 10px
  display flex;
  flex-direction column;
  .day_switch
    align-self: flex-end;
</style>



// WEBPACK FOOTER //
// SchedulerCalendar.vue?4ecd96ce